// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"40":"6b0c64a8","408":"a88840dc","706":"fa09e203","840":"3a75be1e","928":"f0898242"}[chunkId] + ".js";
};